import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, NonLegislativeGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
const TasksReport = lazy(() => import('src/sections/superadmin/reports/tasks-report'));
const OrganizationsReport = lazy(() =>
  import('src/sections/superadmin/reports/organizations-report')
);
const CampaignsReport = lazy(() => import('src/sections/superadmin/reports/campaigns-report'));
const VolunteersReport = lazy(() => import('src/sections/superadmin/reports/volunteers-report'));
const TeamsReport = lazy(() => import('src/sections/superadmin/reports/teams-report'));
const VotersReport = lazy(() => import('src/sections/superadmin/reports/voters-report'));
const DoNotContactListPage = lazy(() => import('src/pages/do-not-contact'));
const NewMoverReport = lazy(() => import('src/sections/superadmin/reports/new-movers-report'));
const DistrictLeanings = lazy(() => import('src/sections/district-leanings/view'));
const ActivityReport = lazy(() => import('src/sections/superadmin/reports/activity-report'));
const AbsenteeReport = lazy(() => import('src/sections/superadmin/reports/absentee-report'));
const PinnedLocationReport = lazy(() =>
  import('src/sections/superadmin/reports/pinned-location-report')
);
const TextRepliesPage = lazy(() => import('src/pages/text-replies'));
const VoicemailRepliesPage = lazy(() => import('src/pages/voicemail-replies'));
const BadNumbersReportPage = lazy(() => import('src/pages/bad-numbers-report'));
const ManualActivitiesReport = lazy(() =>
  import('src/sections/superadmin/reports/manual-activities-report')
);
const PotentialCandidateReport = lazy(() =>
  import('src/sections/superadmin/reports/potential-candidate-report')
);
const VoterContactUpdatesReport = lazy(() =>
  import('src/sections/manager/voter-contact-updates')
);

export const reportsRoutes = [
  {
    path: 'reports',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'tasks', element: <TasksReport />, index: true },
      { path: 'organizations', element: <OrganizationsReport />, index: true },
      { path: 'campaigns', element: <CampaignsReport />, index: true },
      { path: 'volunteers', element: <VolunteersReport />, index: true },
      { path: 'teams', element: <TeamsReport />, index: true },
      { path: 'voters', element: <VotersReport />, index: true },
      { path: 'do-not-contact', element: <DoNotContactListPage />, index: true },
      { path: 'new-movers', element: <NewMoverReport />, index: true },
      {
        path: 'district-leanings',
        element: (
          <NonLegislativeGuard>
            <DistrictLeanings />
          </NonLegislativeGuard>
        ),
        index: true,
      },
      { path: 'activity', element: <ActivityReport />, index: true },
      { path: 'absentee', element: <AbsenteeReport />, index: true },
      { path: 'pinned-locations', element: <PinnedLocationReport />, index: true },
      { path: 'replies', element: <TextRepliesPage />, index: true },
      { path: 'voicemail-replies', element: <VoicemailRepliesPage />, index: true },
      { path: 'bad-numbers', element: <BadNumbersReportPage />, index: true },
      { path: 'potential-candidates', element: <PotentialCandidateReport />, index: true },
      { path: 'manual-activities', element: <ManualActivitiesReport />, index: true },
      {
        path: 'voter-contact-updates',
        element: (
          <NonLegislativeGuard>
            <VoterContactUpdatesReport />
          </NonLegislativeGuard>
        ),
        index: true,
      },
    ],
  },
];
